module.exports = __webpack_public_path__ + "static/media/footer_ico_consulting_store_disable.2cbd77e6.svg";